import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms'
import dayjs from 'dayjs'

import { SensorOperator } from '@shared/modules/notifications/shared/notification.model'

export class LinValidators {
  static unsignedInt(control: AbstractControl): ValidationErrors | null {
    const value = String(control.value)

    return value.match(/^[0-9]*$/) ? null : { unsignedInt: true }
  }

  static dateInFuture(control: AbstractControl): ValidationErrors | null {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { value } = control
    if (!(value instanceof Date)) {
      return null
    }

    const valueDate = dayjs(value).startOf('day')
    const tomorrowDate = dayjs().startOf('day').add(1, 'day')

    return valueDate.isBefore(tomorrowDate) ? { dateInFuture: true } : null
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static formArrayMaxLength(max: number): ValidationErrors | any {
    return (control: AbstractControl[]) => {
      if (!(control instanceof FormArray)) return

      return control.length > max ? { maxLength: true } : null
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static formArrayMinLength(min: number): ValidationErrors | any {
    return (control: AbstractControl[]) => {
      if (!(control instanceof FormArray)) return

      return control.length < min ? { minLength: true } : null
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static macAddress(control: AbstractControl): ValidationErrors | any {
    const regExp = /^(([A-Fa-f0-9]{2}[:]){5}[A-Fa-f0-9]{2}[,]?)+$/i

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return regExp.test(control.value) ? null : { macAddress: true }
  }

  static sensorRangeValidator(startField: string, endField: string, operatorField: string) {
    return (formGroup: FormGroup) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const start = formGroup.get(startField).value
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const end = formGroup.get(endField).value
      const isOutside = formGroup.get(operatorField).value === SensorOperator.Outside

      return isOutside && +start >= +end ? { isSecondMoreThanFirst: true } : null
    }
  }

  static maxValue(value: number): ValidatorFn {
    return (c: AbstractControl): { [key: string]: number } | null => {
      if (+c.value > value) {
        return { maxValue: value }
      }

      return null
    }
  }

  static minValue(value: number): ValidatorFn {
    return (c: AbstractControl): { [key: string]: number } | null => {
      if (+c.value < value) {
        return { minValue: value }
      }

      return null
    }
  }

  static yearValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return

      const value = <number>control.value
      const validYear = value >= 1900 && value <= dayjs().year()

      return validYear ? null : { yearNotValid: true }
    }
  }
}
